module.exports = __webpack_public_path__ + "static/media/coach.34d4ba5d.png";